'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Component, createRef } from 'react';
import { DragSource } from 'react-dnd-compat';
import DragTypes from 'simple-menus-core/enums/DragTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const SET_DELAY_TIME = 500;
const UNSET_DELAY_TIME = 100;
const source = {
  canDrag(props) {
    return !props.readOnly;
  },
  beginDrag(props, monitor, component) {
    const sourceBoundingRect = component.ref.current.getBoundingClientRect();
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(true), {
        timeout: SET_DELAY_TIME
      });
    } else {
      props.setIsDragging(true);
    }
    return {
      id: props.id,
      parentId: props.parentId,
      menuId: props.menuId,
      label: props.label,
      width: sourceBoundingRect.width
    };
  },
  endDrag(props) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => props.setIsDragging(false), {
        timeout: UNSET_DELAY_TIME
      });
    } else {
      props.setIsDragging(false);
    }
  },
  isDragging(props, monitor) {
    return props.id === monitor.getItem().id;
  }
};
export default function menuDragSource() {
  return function (WrappedComponent) {
    class DecoratedComponent extends Component {
      constructor(props) {
        super(props);
        this.ref = /*#__PURE__*/createRef();
      }
      render() {
        const _this$props = this.props,
          rest = Object.assign({}, (_objectDestructuringEmpty(_this$props), _this$props));
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
          ref: this.ref
        }, rest));
      }
    }
    return DragSource(DragTypes.ADVANCED_MENUS_MENU_NODE, source, monitor => ({
      isDragging: monitor.isDragging()
    }))(DecoratedComponent);
  };
}